import { useEffect, useState } from 'react'
import useInactivityTimer from '@chegg-wt/core/hooks/useInactivityTimer'
import {
  useQueryStringQAParams,
  intOrUndefined,
  exitIntentTimeoutKey,
} from '@chegg-wt/core/hooks/useQueryStringQAParams'

export const mouseEventName = 'mouseout'

interface ExitIntentValues {
  exitTriggered: boolean
  setExitTriggered: (value: boolean) => void
}

export const useExitIntent = (): ExitIntentValues => {
  const [exitTriggered, setExitTriggered] = useState(false)

  const queryStringVal = intOrUndefined(useQueryStringQAParams()[exitIntentTimeoutKey])
  const inactivityTimeMs = queryStringVal ?? 60 * 1000

  useInactivityTimer(() => {
    setExitTriggered(true)
  }, inactivityTimeMs)

  useEffect(() => {
    const mouseOutHandler = (event) => {
      if (event.clientY <= 0) {
        setExitTriggered(true)
      }
    }
    document.addEventListener(mouseEventName, mouseOutHandler)
    return () => {
      document.removeEventListener(mouseEventName, mouseOutHandler)
    }
  }, [])

  return { exitTriggered, setExitTriggered }
}

export default useExitIntent
